import { initialsFromName } from './permissions';

export function teamAlias(member = {}) {
  return String(member.alias || member.preferred_name || member.nombre_preferido || '').trim();
}

export function teamDisplayName(member = {}, fallback = 'Equipo') {
  return teamAlias(member) || member.displayName || member.display_name || member.name || member.nombre || member.email || fallback;
}

export function teamFormalName(member = {}, fallback = 'Miembro') {
  return member.name || member.nombre || member.email || fallback;
}

export function teamInitials(member = {}, fallback = 'EQ') {
  return member.initials || initialsFromName(teamDisplayName(member, ''), member.email) || String(fallback).slice(0, 2).toUpperCase();
}

export function teamAvatarEmoji(member = {}) {
  return String(member.avatar_emoji || member.avatarEmoji || '').trim();
}

export function teamMentionName(member = {}) {
  return String(teamDisplayName(member, 'Miembro')).split(/\s+/)[0] || 'Miembro';
}

export function teamOptionLabel(member = {}) {
  const name = teamDisplayName(member, 'Diseñador');
  const role = member.role || member.cargo || '';
  return role ? `${name} · ${role}` : name;
}

